import React from 'react';
import InfoDialog from '../../../../components/shared/InfoDialog';
import LoaderContainer from '../../../../components/material-ui/loader_container/LoaderContainer';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CusButton from '../../../../components/material-ui/CusButton';
import { IconCopy } from '@tabler/icons-react';
import Card from '../../../../components/material-ui/adaptive/Card';
import useToast from '../../../../hooks/useToast';
import ShowContainer from '../../../../components/material-ui/ShowContainer';

export default function PaymentError({ openErrorId, setOpenErrorId, reply, setReply }) {
  const { t } = useTranslation();
  const { infoToast } = useToast();

  return (
    <InfoDialog
      open={openErrorId}
      maxWidth="lg"
      onClose={() => {
        setOpenErrorId(null);
        setReply(null);
      }}>
      <ShowContainer condition={reply}>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={3}>
          <Box>
            <Typography component={'span'} fontWeight={600}>
              {t('Error')}:
            </Typography>{' '}
            <Typography component={'span'}>#{openErrorId}</Typography>
          </Box>
          <CusButton
            onClick={() => {
              navigator.clipboard.writeText(JSON.stringify(reply, null, 2)).then((e) => {
                infoToast('copied to your clipboard');
              });
            }}>
            <IconCopy />
          </CusButton>
        </Stack>
        <Card>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              maxHeight: '50svh',
              overflow: 'auto'
            }}>
            {JSON.stringify(reply, null, 2)}
          </pre>
        </Card>
      </ShowContainer>
    </InfoDialog>
  );
}
